var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotConnected)?_c('div',{staticClass:"connection-status position-fixed bottom-0 start-0 m-4 fs-1 text-center"},[_c('span',{staticClass:"bi bi-wifi-off"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }